<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatório de Movimentações - Estoque</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Movimentações de Estoque</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input type="datetime-local" label="Data Início" name="DT_INIC" formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input type="datetime-local" label="Data Final" name="DT_FIM" formControlName="DT_FIM"
              width="100%"></app-input>
            <app-input type="select" label="Produto" name="FK_PROD" formControlName="FK_PROD" width="100%"
              [selectData]="produtoOptions" (ngModelChange)="onSelectChange($event, 'FK_PROD')"></app-input>
          </form>
        </div>
      </div>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
